module.exports = __webpack_public_path__ + "img/CIBN.b9e95aeb.png";